var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCasestudies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.694,
    height: 27.694,
    viewBox: "0 0 27.694 27.694",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.005 -10.005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.757,18.879a8.9,8.9,0,1,0-3.011,6.65l1.2,1.2-1.08,1.08a.554.554,0,0,0,0,.783L33.2,36.929A2.635,2.635,0,0,0,36.929,33.2L28.59,24.864a.554.554,0,0,0-.783,0l-1.08,1.08-1.2-1.2A8.806,8.806,0,0,0,27.757,18.879Zm.441,7.16,7.947,7.947a1.527,1.527,0,0,1-2.16,2.16L26.039,28.2ZM13.384,24.373a7.77,7.77,0,1,1,10.99,0h0a7.77,7.77,0,0,1-10.988,0Z",
    transform: "translate(0 0)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.288,54.288a.694.694,0,1,0-.981,0A.694.694,0,0,0,54.288,54.288Z",
    transform: "translate(-19.222 -19.222)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.519,16.257A4.434,4.434,0,0,0,21.26,15,4.623,4.623,0,0,0,17,18.749c-.074.344-.12.681-.164,1.007a6.752,6.752,0,0,1-.322,1.509l-.476,1.245a.554.554,0,0,0,.517.752h.554v.222a1.636,1.636,0,0,0,.6,1.273A1.549,1.549,0,0,0,19,25.08l.52-.1c.094-.019.121,0,.13.01a.6.6,0,0,1,.118.421v1.225a.554.554,0,0,0,.554.554h3.1a.554.554,0,0,0,.554-.554A9.326,9.326,0,0,1,25.4,21.7a3.762,3.762,0,0,0,.567-1.993A4.807,4.807,0,0,0,24.519,16.257Zm-.057,4.857a10.462,10.462,0,0,0-1.58,4.964H20.872v-.671a1.6,1.6,0,0,0-.525-1.279,1.239,1.239,0,0,0-1.051-.238l-.52.1a.444.444,0,0,1-.372-.1.532.532,0,0,1-.191-.415v-.776a.554.554,0,0,0-.554-.554h-.3l.189-.494a7.7,7.7,0,0,0,.385-1.754c.044-.319.085-.621.15-.924A3.517,3.517,0,0,1,21.3,16.108a3.309,3.309,0,0,1,2.449.947,3.693,3.693,0,0,1,1.111,2.651A2.657,2.657,0,0,1,24.462,21.114Z",
    transform: "translate(-2.673 -2.227)",
    fill: "#0080ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasestudies);
export default __webpack_public_path__ + "static/media/casestudies.5bb08b85.svg";
export { ForwardRef as ReactComponent };